export const getFullLogoUrl = (
  logo?: string | null,
  companyId?: string,
): string | null => {
  if (!logo) return null;

  if (/^https?:\/\//i.test(logo) || logo.startsWith("data:")) {
    return logo;
  }

  const baseUrl = import.meta.env.VITE_API_BASE_URL?.replace(/\/$/, "");

  if (companyId) {
    return baseUrl
      ? `${baseUrl}/api/companies/public/${companyId}/logo`
      : `/api/companies/public/${companyId}/logo`;
  }

  const normalizedLogo = logo.startsWith("/") ? logo : `/${logo}`;

  return baseUrl ? `${baseUrl}${normalizedLogo}` : normalizedLogo;
};
